export function setServices(state, servicios) {
  state.servicios = servicios;
}

export function setService(state, servicio) {
  state.servicioSeleccionado = servicio;
}

export function clearServices(state) {
  state.servicios = [];
}

export function setNecesitaRecargar(state, necesitaRecargar) {
  state.necesitaRecargar = necesitaRecargar;
}

export function setFiltro(state, filtro) {
  state.filtro = filtro;
}
